import { render } from "./SelectCard.vue?vue&type=template&id=05923d1d&scoped=true"
import script from "./SelectCard.vue?vue&type=script&lang=js"
export * from "./SelectCard.vue?vue&type=script&lang=js"

import "./SelectCard.vue?vue&type=style&index=0&id=05923d1d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05923d1d"]])

export default __exports__